import { Component, OnInit } from "@angular/core";
import { Chart } from "chart.js";

import { ProfileService } from "../services/profile.service";
import { PaymentService } from "../services/payment.service";
import { ResultService } from "../services/result.service";
import { TimetableService } from "../services/timetable.service";
import { AttendanceService } from "../services/attendance.service";
import { UserService } from "../services/user.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, Route } from "@angular/router";
import { CbtService } from "../services/cbt.service";
import { MessagesComponent } from "../messages/messages.component";
import { MatDialog } from "@angular/material/dialog";
import { ClassService } from "../services/class.service";
import { LogService } from "../services/log.service";
import { GeneralService } from "../services/general.service";
import { NotificationsService } from "../services/notifications.service";
import { forkJoin } from "rxjs";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit {
  public paymentEligible: any = { control: true };
  public urgency = {
    0: "Not Urgent",
    1: "Urgent",
    2: "Very Urgent",
  }

  chartColors = [
    "#3498DB",
    "#9B59B6",
    "#1ABC9C",
    "#F1C40F",
    "#E74C3C",
    "#2C3E50",
    "#95A5A6",
    "#4CAF50",
    "#8E44AD",
    "#3B3F54",
    "#2196F3",
    "#9C27B0",
    "#673AB7",
    "#2ECC71",
    "#03A9F4",
    "#00BCD4",
    "#4DB6AC",
    "#F7DC6F",
    "#5C6BC0",
    "#E67E73"
  ]
  quickLinks = []

  //   [x: string]: {
  //     label: string, color:
  //     string, value: string,
  //     icon: string, tert?: boolean
  //   }
  // } 
  topCards = {
    student_id: { label: "Student ID", color: "#607D8B", icon: "account_box", value: "", tert: false },
    matric_no: { label: "Matric Number", color: "#607D8B", icon: "account_box", value: "", tert: true },
    level_semester: { label: "Level | Semester", color: "#2196F3", icon: "school", value: "", tert: true },
    class: { label: "Class", color: "#2196F3", icon: "school", value: "", tert: false },
    cgpa: { label: "Current CGPA", color: "#E91E63", icon: "insights", value: "", tert: true },
    current_term: { label: "Current Term", color: "#E91E63", icon: "insights", value: "", tert: false },
    current_session: { label: "Current Session", color: "#3F51B5", icon: "insights", value: "", tert: false },
    dept_programme: { label: "Dept | Programme", color: "#3F51B5", icon: "category", value: "", tert: true },
  }

  getCards () {
    return Object.values(this.topCards)
      .filter((data) => this.system == 'tert' ? data.tert : !data.tert)
      .map((data) => data)
  }

  public resp;
  public registeredSemesterCourses;
  public paymentDetails = [];
  public profileDetails: any = [];
  public cgpa: any;
  public studentDept;
  public studentName;
  public studentLevel;
  public semester;
  public resultChart;
  public timetable = [];
  public getCourses;
  public studentDetails;
  public attendance;
  public daysLeft;
  public a;
  public hrsLeft;
  public b;
  public minLeft;
  public secLeft;
  public stop;
  public totalSec;
  public d;
  public start;
  public lastname;
  public firstname;
  public student_id;
  public dept;
  public programme;
  public level;
  public sessions = [];
  public semesters = [];
  // public data;
  public semester_alias = [];
  public details = [];
  public semester_cgpa = [];
  public semester_result = [];
  public tabs = [];
  public reg;
  public attained;
  public tattained;
  public gradee;
  public q;
  public cumUnit = 0;
  public cumTotal = 0;
  public cumTotalAttainable = 0;
  public courses = [];
  public x;
  public tcp;
  public mark;
  public attainedGrade;
  public total = 0;
  public currentCGPA;
  public regStatus;
  public isFullyLoaded;
  public courseRegTimer;
  public courseRegCloses;
  LineChart: any;
  public deptFull;
  public programmeFull;
  public currentSemester;
  public examCategories = [
    // { exam_title: "Science, Technology and Mathematics" },
    // { exam_title: "National Value" },
    // { exam_title: "Management Science" },
  ];
  public totalTimeLeft;
  public displayTime;
  public system;
  public session_year;
  public matric_no;
  public current_username;

  public cd_id;
  public virtualClasses = [];
  constructor (
    private _profileService: ProfileService,
    private __paymentService: PaymentService,
    private __resultService: ResultService,
    private _timetableService: TimetableService,
    private _attendanceService: AttendanceService,
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private _Router: Router,
    private _general: GeneralService,
    private _cbtService: CbtService,
    private _paymentService: PaymentService,
    private dialog: MatDialog,
    public _class: ClassService,
    public notificationService: NotificationsService,
    public router: Router,
    public log: LogService
  ) { }

  watchProgram () {
    this._userService.programChange.subscribe(data => {
      this.ngOnInit(1);
    })
  }

  topTermSubjects: any[] = [];
  resultLabel = ""
  ngOnInit (time = 0) {
    if (time == 0) {
      this.watchProgram();
      this.log
        .addLog({
          action: "Access",
          component: "Dashboard",
          details: `Accessed Dashboard`,
        }).subscribe(data => { });
    }

    this.system = localStorage.getItem("p_system");
    this.quickLinks = this.system == 'tert' ? [
      { link: "/home/notice-board", label: "Notice Board", icon: "bx bx-chalkboard", color: "rgb(59 130 246)" },
      { link: "/home/pay-tuition", label: "Pay Tuition", icon: "bx bx-credit-card", color: "rgb(34 197 94)" },
      { link: "/home/course-registration", label: "Register Courses", icon: "bx bx-credit-card-front", color: "rgb(249 115 22)" },
      { link: "/home/semester-result", label: "Semester Result", icon: "bx bx-list-ul", color: "#607D8B" },
      { link: "/home/document-list", label: "Upload Documents", icon: "bx bx-folder-open", color: "#E91E63" },
    ] : [
      { link: "/home/my-profile", label: "My profile", icon: "bx bx-user", color: "rgb(249 115 22)" },
      { link: "/home/notice-board", label: "Notice Board", icon: "bx bx-chalkboard", color: "rgb(59 130 246)" },
      { link: "/home/pay-tuition", label: "Pay School Fee", icon: "bx bx-credit-card", color: "rgb(34 197 94)" },
      { link: "/home/semester-result", label: "Result", icon: "bx bx-list-ul", color: "#607D8B" },
      { link: "/home/document-list", label: "Resources", icon: "bx bx-book-open", color: "#E91E63" },
    ]
    this.spinner.show();
    this.isFullyLoaded = false;
    this.resultChart = this.LineChart;
    // this.attendance = this._attendanceService.getAttendance();
    // this.getCourses = this.__resultService.getCourses();
    //this.studentDetails = this._profileService.studentDetails;
    this.__resultService.getGrades().subscribe(grades => {

      this.__resultService.semesterResult().subscribe((resultArr: any[]) => {
        let termResults: {
          key: string,
          data: { name: string, value: number | string }[]
        }[] = [];
        resultArr.forEach(element => {
          let key = element.session_year + ' ' + element.term;
          if (this.system == 'tert') {
            key = element.session_year;
          }
          const aResult = { name: (element.title ?? element.name).toUpperCase(), value: element.marks }
          if (!termResults.find(each => each.key == key)) {
            termResults.push({ key, data: [aResult] })
          } else {
            termResults = termResults.map(each => each.key == key ? ({ ...each, data: [...each.data, aResult] }) : each)
          }
        });
        termResults.sort((a, b) => b.key > a.key ? -1 : 1);
        this.topTermSubjects = termResults[termResults.length - 1]?.data
          ?.sort((a, b) => (Number(b.value) - Number(a.value))) ?? [];
        this.resultLabel = termResults[termResults.length - 1]?.key;

        this.sessions.length = 0;
        this.semesters.length = 0;
        this.semester_alias.length = 0;
        this.semester_result.length = 0;
        this.details.length = 0;
        this.semester_cgpa.length = 0;
        for (let i in resultArr) {
          if (this.sessions.indexOf(resultArr[i].session_year) <= -1) {
            this.sessions.push(resultArr[i].session_year);
          }
          if (this.semesters.indexOf(resultArr[i].term) <= -1) {
            this.semesters.push(resultArr[i].term);
            this.semester_alias.push(resultArr[i].term.charAt(0));
          }
        }

        for (let i in this.sessions) {
          for (let j in this.semesters) {
            this.details.push({
              session_year: this.sessions[i],
              semester: this.semesters[j],
              tab: resultArr.filter(
                x =>
                  x.session_year == this.sessions[i] &&
                  x.term == this.semesters[j]
              )
            });
          }
        }

        for (let x in this.details) {
          this.semester_result.push(
            this.details[x].session_year.split("/")[1] +
            "|" +
            this.details[x].semester.charAt(0)
          );
          this.total = 0;
          this.q = 0;
          let dd = this.details[x].tab;

          for (let y in dd) {

            //map through grades array to get the number of points and grade
            for (let g in grades) {
              if (dd[y].marks >= grades[g].score) {
                this.gradee = (!grades[g].point) ? 0 : grades[g].point;
                break;
              }
            }
            // if (dd[y].marks <= 100 && dd[y].marks >= 70) {
            //   this.gradee = 5;
            // } else if (dd[y].marks <= 69 && dd[y].marks >= 60) {
            //   this.gradee = 4;
            // } else if (dd[y].marks <= 59 && dd[y].marks >= 50) {
            //   this.gradee = 3;
            // } else if (dd[y].marks <= 49 && dd[y].marks >= 45) {
            //   this.gradee = 2;
            // } else if (dd[y].marks <= 44 && dd[y].marks >= 40) {
            //   this.gradee = 1;
            // } else if (dd[y].marks <= 39 && dd[y].marks >= 0) {
            //   this.gradee = 0;
            // }
            this.mark = dd[y].unit;
            this.tattained = dd[y].unit * this.gradee;
            this.total += this.mark;
            this.q += this.tattained;
            this.cumUnit += dd[y].unit;
            this.cumTotal += this.mark;
            this.cumTotalAttainable += this.tattained;
            //alert(this.tattained);
          }
          this.details[x].tot = this.total;
          this.details[x].attainedGrade = this.q;

          this.details[x].cummulativeUnits = this.cumUnit;
          this.details[x].cummulativeTotal = this.cumTotal;
          this.details[x].cummulativeTotalAttainable = this.cumTotalAttainable;
          this.semester_cgpa.push(
            Math.round(
              (this.details[x].cummulativeTotalAttainable /
                this.details[x].cummulativeTotal) *
              100
            ) / 100
          );
        }

        this.currentCGPA = this.semester_cgpa[this.semester_cgpa.length - 1];
        this.topCards.cgpa.value = this.currentCGPA;
        //line chart

        let x = this.semester_cgpa;

        if (document.getElementById('chartContainer') && this.semester_result.length) {
          setTimeout(() => {
            this.LineChart = new Chart("lineChart", {
              type: "line",
              options: this._general.defaultChartOptions,
              data: {
                labels: this.semester_result,
                datasets: [
                  {
                    label: `${resultArr[0]?.ca_unit} PROGRESS`,
                    data: x,
                    fill: false,
                    // lineTension: 0.2,
                    borderColor: "#258CF4",
                    pointBackgroundColor: "#258CF4",
                    backgroundColor: '#258CF4',
                    borderWidth: 1
                  }
                ]
              }
            });
          }, 400);
        }

      });
    })

    this._userService.getUserData().subscribe(data => {
      // console.log('term: ',data);
      this.topCards.cgpa.label = `Current ${data.ca_unit}`;
      this.firstname = data.firstname;
      this.lastname = data.lastname;
      this.student_id = data.student_id;
      this.cd_id = data.cd_id;
      this.matric_no = data.matric_no;
      this.current_username = data.current_username;
      this.dept = data.category;
      this.programme = data.name;
      this.level = data.tag;
      this.deptFull = data.description;
      this.programmeFull = data.class_description;
      this.currentSemester = data.term;
      this.session_year = data.session_year
      if (data.semester_alias == "0") {
        this.semester = "";
      } else {
        this.semester = data.semester_alias;
      }

      this.topCards.matric_no.value = data.matric_no;
      this.topCards.current_session.value = data.session_year;
      this.topCards.current_term.value = data.term;
      this.topCards.student_id.value = data.student_id;
      this.topCards.class.value = `${data.name} ${data.tag}`;
      this.topCards.level_semester.value = `${data.tag} | ${this.semester}`;
      this.topCards.dept_programme.value = `${data.category} | ${data.name}`;

      this.isFullyLoaded = true;

      this.loadVirtualClasses()

    });
    setTimeout(() => {
      this.spinner.hide();
    }, 1500);

    this.__resultService.sem_reg_courses().subscribe(data => {
      data.pop();
      data.pop();
      this.registeredSemesterCourses = data;
      if (this.registeredSemesterCourses.length >= 1) {
        this.regStatus = true;
      } else {
        this.regStatus = false;
      }
    });

    //get current semester details
    this.__resultService.getSemesterInfo().subscribe(data => {
      this.countDown(data.current_date_time, data.course_reg_ends);
    });

    this.loadInvoices();
    this.loadlogs();

    forkJoin([
      this._cbtService.loadExamCategories({ request: 'load_exam_categories' }),
      this.notificationService.getAllNoticeFromNoticeBoard({ limit: 5 })
    ]).subscribe(([
      examCategories,
      noticeboard
    ]) => {
      this.loadExamCategories(examCategories);
      this.getNotice(noticeboard);
    })
  }

  loadExamCategories (data) {
    // .subscribe(data => {
    // console.log(data);
    this.examCategories = data;
    // })
  }

  allNoticeArray: any[] = [];
  getNotice (data) {
    //  .subscribe((data: any) => {
    this.allNoticeArray = data;
    // })
  }

  paymentHistory = [];
  balance = 0;
  loadInvoices () {
    this._paymentService.studentPaymentHistory().subscribe(data => {
      this.paymentHistory = data.map(i => ({ ...i, label: `${i.category ?? ''} - ${i.name ?? ''} - ${i.tag ?? ''} - ${i.term ?? ''}` })).slice(0, 4);
      this.balance = this.paymentHistory.reduce((p, v) => p + v.amount_remaining, 0)
    })
  }

  recentLogs: {
    component: string,
    details: string,
    created_at: string
  }[] = [];
  loadlogs () {
    this.log.getlogs({ limit: 5 }).subscribe((data: any[]) => {
      this.recentLogs = data.map(e => ({ ...e, ago: this._general.timeAgo(e.created_at) }));
    })
  }

  loadVirtualClasses () {
    let form = new FormData();
    form.append('cd_id', this.cd_id)
    this._class.loadVirtualClasses(form).subscribe(data => {
      this.virtualClasses = data;
      // console.log(this.virtualClasses)
    })
  }

  joinVirtualClass (code, title) {
    this._paymentService.getPaymentEligibility({ key: 'v_class' }).subscribe(data => {
      this.paymentEligible = data;
      if (this.paymentEligible.control == false) {
        if (!this.paymentEligible.control) {
          this.dialog.open(MessagesComponent, {
            disableClose: true,
            data: { for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to write tests/exams` }
          })
        }
        return;
      } else {
        localStorage.setItem('tmp_class_code', code)
        localStorage.setItem('tmp_class_name', title)

        sessionStorage.setItem('edoz_name', `${this.lastname} ${this.firstname}`)

        this.router.navigate(['home/virtual-class'])
      }
    })
  }

  startExam (examDetails) {
    this._paymentService.getPaymentEligibility({ key: 'exam' }).subscribe(data => {
      this.paymentEligible = data;
      if (this.paymentEligible.control == false) {
        if (!this.paymentEligible.control) {
          this.dialog.open(MessagesComponent, {
            disableClose: true,
            data: { for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to write tests/exams` }
          })
        }
        return;
      } else {
        this._cbtService.examTobeTaken = examDetails;
        this._Router.navigate(['/cbt/exam-details']);
      }
    });
  }

  countDown (start, end) {
    // let _start:any = new Date("2020-01-01 01:00:00");//new Date(start);
    // let _end:any = new Date("2020-01-01 01:01:00");//new Date(end);
    let _start: any = new Date(start);
    let _end: any = new Date(end);
    let counterEnd = (_end - _start) / 1000;

    if (counterEnd <= 0) {
      this.displayTime = "0d " + "0h " + "0m " + "0s"
      this.resp = "Course Registration Closed"
    }
    // console.log('counter end: ', counterEnd);
    // Start if not past end date 
    if (counterEnd > 0) {
      let counterTicker = setInterval(() => {
        // Stop if passed end time
        counterEnd--;
        if (counterEnd <= 0) {
          //this.saveExam(this.CBTForm.value);
          clearInterval(counterTicker);
          counterEnd = 0;
        }

        // Calculate remaining time
        let days = Math.floor(counterEnd / 86400);
        let hrs = Math.floor((counterEnd - (86400 * days)) / 3600);
        let mins = Math.floor((counterEnd - (days * 86400) - (hrs * 3600)) / 60);
        let secs = Math.floor(counterEnd - (days * 86400) - (3600 * hrs) - (60 * mins));
        this.displayTime = days + "d " + hrs + "h " + mins + "m " + secs + "s";
        this.totalTimeLeft = counterEnd;
        // console.log(this.displayTime);
      }, 1000);
    }

  }
}
